function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6877 55.9473H3.41504V212.632H30.6877V55.9473Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M195.135 81.237C182.541 62.7579 159.775 52.7363 137.554 52.7363C93.0881 52.7363 57.7402 87.5512 57.7402 134.427C57.7402 181.036 93.6326 215.851 137.554 215.851C148.537 215.851 159.254 213.174 169.692 208.088C180.409 203.002 188.971 196.19 195.135 186.817V212.642H221.469V55.9456H195.135V81.237ZM137.843 189.099C108.219 189.099 84.422 164.793 84.422 134.16C84.422 103.771 108.219 79.2211 137.843 79.2211C168.221 79.2211 191.775 103.783 191.775 134.16C191.775 164.793 168.221 189.099 137.843 189.099Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M442.03 52.1562C414.05 52.1562 394.934 62.1894 385.202 81.9777C375.899 63.545 354.662 52.1562 329.452 52.1562C308.053 52.1562 291.775 59.3162 282.252 72.883V55.3655H255.223V213.208H282.518V128.019C282.518 96.3092 300.372 75.8142 328.004 75.8142C353.434 75.8142 370.511 92.5902 370.511 117.557V213.22H397.147V123.304C397.147 108.706 402.082 95.8805 411.05 87.2144C419.044 79.4868 429.865 75.4434 441.543 75.8257C467.877 76.6947 483.587 93.2042 483.587 119.979V213.232H509.991V120.245C509.991 100.086 503.573 82.9973 491.431 70.8207C479.301 58.5979 462.2 52.1562 442.03 52.1562Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0541 0C7.63495 0 0 7.63495 0 17.0541C0 26.4732 7.63495 34.1082 17.0541 34.1082C26.4732 34.1082 34.1082 26.4732 34.1082 17.0541C34.0966 7.63495 26.4616 0 17.0541 0Z",
  fill: "white"
});
const SvgIamLogoW = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 216,
    viewBox: "0 0 510 216",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIamLogoW, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iam_logo_w.e748f4c3.svg";
export { ForwardRef as ReactComponent };